import React from "react";
import ReactDOM from "react-dom";
import "./styles/tailwind.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { bootstrapPwa } from "./services/pwa";
import "react-tooltip/dist/react-tooltip.css"; //needed for react-tooltip
console.log("[index] entry point reached");
console.log("[index] document.getElementById('root') =", document.getElementById("root"));
console.log("[index] PUBLIC_URL =", process.env.PUBLIC_URL);
console.log("PUBLIC_URL from code:", process.env.PUBLIC_URL);
console.log("window.location.href:", window.location.href);
console.log("[index] typeof App =", typeof App);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      {
        (() => {
          console.log("[App Inline] invoked");
          console.log("[App Inline] url:", process.env.PUBLIC_URL);
          return <div>Test</div>;
        })()
      }
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);


bootstrapPwa();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
